module.exports = __webpack_public_path__ + "static/media/home-solid.e72fecb6.svg";